export const typography = {
    fontFamily: {
        sans: '"Hiragino Sans", "Hiragino Kaku Gothic ProN", "Yu Gothic", Meiryo, sans-serif',
        mono: '"Hiragino Sans Mono", "Yu Gothic Mono", monospace',
    },
    fontSize: {
        /** 12px */
        xs: '0.75rem',
        /** 14px */
        sm: '0.875rem',
        /** 16px */
        base: '1rem',
        /** 18px */
        lg: '1.125rem',
        /** 20px */
        xl: '1.25rem',
        /** 24px */
        '2xl': '1.5rem',
        /** 30px */
        '3xl': '1.875rem',
        /** 36px */
        '4xl': '2.25rem',
        /** 48px */
        '5xl': '3rem',
    },
    fontWeight: {
        /** 400 */
        normal: '400',
        /** 500 */
        medium: '500',
        /** 600 */
        semibold: '600',
        /** 700 */
        bold: '700',
    },
    lineHeight: {
        /** 1 */
        none: '1',
        /** 1.25 */
        tight: '1.25',
        /** 1.5 */
        normal: '1.5',
        /** 1.75 */
        relaxed: '1.75',
    },
};
